export default __webpack_public_path__ + "static/media/group.3f222507.svg";